import React, { useRef, useState } from "react";
import {
  Grid,
  IconButton,
  Switch,
  Box,
  Button as MuiButton,
  Tooltip,
  FormControl,
  FormGroup,
  FormControlLabel,
  MenuItem,
  Radio,
  Checkbox,
} from "@mui/material";
import { Button, Card } from "antd";
import { message } from "antd";
import { CALL_API } from "common/API";
import { CustomIconButton, CustomTextField } from "common/common";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Select, Divider } from "antd";
import FormOptions from "reusableComponent/formBuilder/options";
import styled from "styled-components";
import Rating from "@mui/material/Rating";

const { Option } = Select;

const optionLabelStyle = {
  textTransform: "none",
  color: "#C9C9C9",
  fontWeight: 400,
};

function FormSection({
  fullFormDetail,
  setFullFormDetail,
  isDisabled,
  linkedFormDetail,
  appraisarform = false, // ✅ appraisee main section passed from appraiser
  onDeleteQuestion,
}) {
  console.log("fullFormDetail", fullFormDetail);
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [emptyQuestionIndices, setEmptyQuestionIndices] = useState([]);

  React.useEffect(() => {
    if (fullFormDetail?.length === 0) {
      setFullFormDetail([
        {
          question: "",
          question_placeholder: "Question",
          options: [{ optionText: "Option 1", placeholder: "Option 1" }],
          formType: "MULIPLE_CHOICE",
          id: 1,
          requiredSwitch: false,
        },
      ]);
    }
  }, []);

  React.useEffect(() => {
    const autoSaveForm = fullFormDetail;
  }, [fullFormDetail]);

  const handleQuestionValue = (text, i) => {
    var questionText = JSON.parse(JSON.stringify(fullFormDetail));
    questionText[i].question = text;
    setFullFormDetail(questionText);

    if (text.trim() !== "") {
      setEmptyQuestionIndices((prev) => prev.filter((idx) => idx !== i));
    }
  };

  const addOption = (i) => {
    var addOptions = JSON.parse(JSON.stringify(fullFormDetail));
    addOptions[i].options.push({
      optionText: "Option " + (addOptions[i].options.length + 1),
    });
    setFullFormDetail(addOptions);
  };

  const deleteQuestion = (i) => {
    let fullFormContent = JSON.parse(JSON.stringify(fullFormDetail));
    fullFormContent.splice(i, 1);
    setFullFormDetail(fullFormContent);
    setEmptyQuestionIndices((prev) =>
      prev.filter((idx) => idx !== i).map((idx) => (idx > i ? idx - 1 : idx))
    );
    onDeleteQuestion?.(i);
  };

  const handleOptionValue = (
    text,
    i,
    optionindex,
    fieldType = "optionText"
  ) => {
    const optionValue = JSON.parse(JSON.stringify(fullFormDetail));
    if (fieldType === "starCount") {
      optionValue[i].starCount = text;
    } else if (fieldType === "starValue") {
      optionValue[i].starValue = text;
    } else {
      optionValue[i].options[optionindex].optionText = text;
    }
    setFullFormDetail(optionValue);
  };

  const handleSeleteFormChange = (value, i) => {
    const optionType = JSON.parse(JSON.stringify(fullFormDetail));
    optionType[i].formType = value;
    optionType[i].options = [{ optionText: "Option 1" }];
    setFullFormDetail(optionType);
  };

  const handleRequiredChange = (event, i) => {
    const requireQuestion = JSON.parse(JSON.stringify(fullFormDetail));
    requireQuestion[i].requiredSwitch = event.target.checked;
    setFullFormDetail(requireQuestion);
  };

  const optionRemove = (i, optionindex) => {
    const questionOption = JSON.parse(JSON.stringify(fullFormDetail));
    if (questionOption[i].options.length > 1) {
      questionOption[i].options.splice(optionindex, 1);
      setFullFormDetail(questionOption);
    }
  };

  const createDuplicate = (i) => {
    const copyForm = JSON.parse(JSON.stringify(fullFormDetail));
    const newOptions = [];
    copyForm[i].options.forEach((opn) => {
      const opn1new = { optionText: opn?.optionText };
      newOptions.push(opn1new);
    });
    const newQuestion = {
      question: copyForm[i].question,
      options: newOptions,
      formType: copyForm[i].formType,
      id: fullFormDetail.length + 1,
      requiredSwitch: false,
    };
    setFullFormDetail((fullFormDetail) => [...fullFormDetail, newQuestion]);
  };

  const addExtraForm = () => {
    // Check for empty questions
    const emptyIndices = fullFormDetail
      .map((item, idx) =>
        !item?.question || item.question.trim() === "" ? idx : null
      )
      .filter((idx) => idx !== null);

    if (emptyIndices.length > 0) {
      setEmptyQuestionIndices(emptyIndices);
      message.error(
        "Please fill in the question field before adding a new one."
      );
      return;
    }

    // ✅ If linkedFormDetail provided, block if appraiser has reached appraisee count
    if (linkedFormDetail && fullFormDetail.length >= linkedFormDetail.length) {
      message.error(
        "Please complete the Appraisee's form first before adding more questions here."
      );
      return;
    }

    setEmptyQuestionIndices([]);
    setFullFormDetail((fullFormDetail) => [
      ...fullFormDetail,
      {
        question: "",
        question_placeholder: "Question",
        options: [{ optionText: "Option 1" }],
        formType: "MULIPLE_CHOICE",
        id: fullFormDetail.length + 1,
        requiredSwitch: false,
      },
    ]);
  };

  return (
    <React.Fragment>
      {fullFormDetail?.map((form, i) => {
        const hasError = emptyQuestionIndices.includes(i);

        return (
          <>
            <div
              className="mt-3 bg_light rounded-2"
              style={{
                border: hasError ? "1px solid red" : "",
                borderRadius: "8px",
              }}
            >
              <Box className="pt-3">
                <div className="px-4">
                  <Grid container>
                    <Grid item md={8} sm={11} xs={11}>
                      <Box sx={{ pb: hasError ? 0 : 2 }}>
                        <CustomTextField
                          className="mt-3 fw-bold"
                          id="standard-basic1"
                          variant="standard"
                          value={form?.question || ""}
                          placeholder={form?.question_placeholder}
                          onChange={(e) =>
                            handleQuestionValue(e.target.value, i)
                          }
                          fullWidth
                          disabled={isDisabled}
                          error={hasError}
                        />
                        {hasError && (
                          <div
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "4px",
                              marginBottom: "8px",
                            }}
                          >
                            Question is required.
                          </div>
                        )}
                      </Box>
                    </Grid>
                    <Grid item md={1} sm={1} xs={1}>
                      {form?.requiredSwitch && (
                        <Box className="text-danger fw-bold">*</Box>
                      )}
                    </Grid>
                    <Grid item md={3} sm={12} xs={12} ref={containerRef}>
                      <Select
                        id={`simple-select-filled${form.id}`}
                        value={form.formType || "MULIPLE_CHOICE"}
                        onChange={(value) => handleSeleteFormChange(value, i)}
                        style={{ width: "100%", borderRadius: "5px" }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        disabled={isDisabled || appraisarform}
                      >
                        <Option value="SHORT_ANS">Short answer</Option>
                        <Option value="PARAGRAPH">Paragraph</Option>
                        <Option value="MULIPLE_CHOICE">Multiple Choice</Option>
                        <Option value="CHECKBOX">Checkboxes</Option>
                        <Option value="DROPDOWN">Dropdown</Option>
                        <Option value="DATE">Date</Option>
                        <Option value="TIME">Time</Option>
                        <Option value="RATING">Rating</Option>
                      </Select>
                    </Grid>
                  </Grid>

                  <FormOptions
                    form={form}
                    i={i}
                    handleOptionValue={handleOptionValue}
                    optionRemove={optionRemove}
                  />

                  <Grid container>
                    <Grid item lg={12}>
                      {fullFormDetail[i]?.formType === "MULIPLE_CHOICE" && (
                        <>
                          <Radio disabled key={`radio-disbaled-${i}`} />
                          <MuiButton
                            size="small"
                            onClick={() => addOption(i)}
                            style={optionLabelStyle}
                            disabled={isDisabled}
                          >
                            Add Option
                          </MuiButton>
                        </>
                      )}

                      {fullFormDetail[i]?.formType === "CHECKBOX" && (
                        <>
                          <Checkbox disabled key={`check-disbaled-${i}`} />
                          <MuiButton
                            size="small"
                            onClick={() => addOption(i)}
                            style={optionLabelStyle}
                            disabled={isDisabled}
                          >
                            Add Option
                          </MuiButton>
                        </>
                      )}

                      {fullFormDetail[i]?.formType === "DROPDOWN" && (
                        <>
                          <MuiButton
                            size="small"
                            onClick={() => addOption(i)}
                            style={optionLabelStyle}
                            disabled={isDisabled}
                          >
                            Add Option
                          </MuiButton>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </div>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: "5px 15px",
                    borderTop: 1,
                    borderColor: "divider",
                    backgroundColor: "#F8F8F8",
                  }}
                >
                  {!isDisabled && !appraisarform && (
                    <>
                      <Tooltip title="Duplicate">
                        <IconButton onClick={() => createDuplicate(i)}>
                          <ContentCopyOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Box
                        sx={{
                          // borderRight: 1,
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          pl: "10px",
                        }}
                      >
                        <Tooltip
                          title={
                            fullFormDetail?.length === 1
                              ? "Cannot delete the question"
                              : "Delete"
                          }
                        >
                          <span>
                            <CustomIconButton
                              onClick={() => deleteQuestion(i)}
                              className="mx-2"
                              disabled={fullFormDetail?.length === 1}
                              style={
                                fullFormDetail?.length === 1
                                  ? {
                                      opacity: 0.4,
                                      cursor: "not-allowed",
                                      pointerEvents: "none",
                                    }
                                  : {}
                              }
                            >
                              <DeleteOutlinedIcon />
                            </CustomIconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </>
                  )}
                  {/* <FormGroup aria-label="position" row>
                    <FormControlLabel
                      value="start"
                      control={
                        <Switch
                          style={{ color: "#2D53DA" }}
                          checked={form.requiredSwitch || false}
                          onChange={(event) => handleRequiredChange(event, i)}
                          disabled={isDisabled}
                        />
                      }
                      label="Required"
                      labelPlacement="start"
                    />
                  </FormGroup> */}
                </Box>
              </Box>
            </div>
          </>
        );
      })}
      {!isDisabled && !appraisarform ? (
        <Box className="mt-3 pb-4">
          <div className="text-center">
            <Button
              className="btn-style rounded-2"
              type="primary"
              onClick={addExtraForm}
            >
              <AddIcon className="pb-1" />
            </Button>
          </div>
        </Box>
      ) : (
        <br></br>
      )}
    </React.Fragment>
  );
}

export default FormSection;
